import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";

import typography from "../../../theme/typography";

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const EventsListTabs = ({
  tabValue,
  handleChangeTabValue,
}: {
  tabValue: number;
  handleChangeTabValue: (event: React.SyntheticEvent, newValue: number) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={tabValue}
      onChange={handleChangeTabValue}
      aria-label="basic auto tabs"
      sx={{
        minHeight: "unset",
        marginBottom: "16px",
        "& .MuiTabs-flexContainer": {
          gap: "16px",
        },
        "& .MuiTabs-indicator": {
          height: "3px",
        },
      }}
    >
      <Tab
        label={t("pages.events.eventList.allEvents")}
        {...a11yProps(0)}
        sx={{
          padding: "0 0 8px",
          minHeight: "unset",
          ...typography.body16Regular,
          textTransform: "capitalize",
        }}
      />
      <Tab
        label={t("pages.events.eventList.myEvents")}
        {...a11yProps(1)}
        sx={{
          padding: "0 0 8px",
          minHeight: "unset",
          ...typography.body16Regular,
          textTransform: "capitalize",
        }}
      />
    </Tabs>
  );
};

export default EventsListTabs;
